import { _, moment } from "../../vendor";
import Recurrencies from "./Recurrencies";
// @ts-ignore
import InboomaBaseAsyncCollection from "../collections/InboomaBaseAsyncCollection";

const RequestHelperCollection = InboomaBaseAsyncCollection.extend({
  url: "/contingents/getAvailables",
});

/**
 * @function AppointmentsGenerator
 *
 * Fetches available events for a certain contingent and timespan;
 * calculates recurrencies for each event (if recurring) and merges
 * it with appointments (if any)
 *
 * @see https://support.inbooma.net/projects/devbx/wiki/Termine_(appointments)
 *
 * @todo This file could contain further separated functions, e.g. to generate appointments
 * without having to catch from available-endpoint or vice versa
 *
 * @param {Number} contingent_id
 * @param {Number} client_id
 * @param {String} begin Formatted date string (YYYY-MM-DD)
 * @param {String} end   Formatted date string (YYYY-MM-DD)
 *
 * @return {Promise} Whereby resolve returns an array of events sorted by date,
 *                   reject returns an error string
 */
export default ({
  contingent_id,
  client_id,
  begin,
  end,
}: {
  contingent_id: any;
  client_id: any;
  begin: any;
  end: any;
}): Promise<unknown> => {
  let sortedEvents: any[] = [];

  const pushSortedEvents: (event: any) => void = (event: any): void => {
    const start: any = moment(event.start).format("Y-MM-DD");

    if (typeof sortedEvents[start] === "undefined") {
      sortedEvents[start] = [];
    }

    sortedEvents[start].push(event);
    sortedEvents.length++;
  };

  return new Promise(
    (
      resolve: (value: PromiseLike<unknown> | unknown) => void,
      reject: (reason?: any) => void,
    ): void => {
      const eventsCollection: any = new RequestHelperCollection();

      // STEP 1: Fetch events & appointments
      eventsCollection.create(
        {
          contingent_id,
          client_id,
          begin,
          end,
        },
        {
          success(model: any, response: any): void {
            if (
              typeof response.data.recurring_events !== "undefined" &&
              response.data.recurring_events.length === 0
            ) {
              resolve([]);
            }

            /**
             *  STEP 2:
             *  Sort events (both regular and recurring) by their start
             *  to enable quicker access in disableDayFn!
             *  Note: day < 1:n > events
             */
            _.each(response.data.recurring_events, (calendar: any): void => {
              _.each(calendar.events, (event: any): void => {
                if (typeof event.toJSON === "function") {
                  event = event.toJSON();
                }

                if (
                  !_.isUndefined(event.separation_count) &&
                  event.separation_count !== "" &&
                  event.separation_count !== null &&
                  event.rrule !== ""
                ) {
                  // == recurring!

                  const recurrencies: { _eventWeekdaysToArray(event: any): number[] } =
                    new Recurrencies({
                      event,
                      max: 100,
                      fromDate: moment(event.start).date(1).toDate(),
                      //toDate : moment(event.start).date(1).add(1,'year'),
                      then: (_event: any) => pushSortedEvents(_event),
                    });
                } else {
                  // Regular, non recurring, event
                  pushSortedEvents(event);
                }
              });

              /**
               * STEP 3: Merge events with appointments (if any)
               * An appointment is like an event modifier, overriding
               * e.g. begin or end time, number of attendees or blocking of that day
               */
              _.each(response.data.appointments, (appointment: any): void => {
                const start: any = moment(appointment.begin).format("Y-MM-DD");

                if (typeof sortedEvents[start] === "undefined") {
                  console.log(start + " problem - got appointment for non existing day");
                  return;
                }

                _.each(sortedEvents[start], (event, key) => {
                  if (typeof event === "undefined") {
                    return;
                  }

                  if (event.id === appointment.event_id) {
                    if (
                      appointment.description == "action:blockday" ||
                      appointment.current_available_pers_count === 0
                    ) {
                      sortedEvents[start].splice(key, 1);

                      if (sortedEvents[start].length == 0) {
                        // no events on that day
                        //console.log('-- removed all events --', that._sortedEvents[start])
                        sortedEvents.splice(start, 1);
                      }
                      return;
                    }

                    event.start = appointment.begin;
                    event.end = appointment.end;

                    /*if (appointment.max_pers_count != appointment.current_available_pers_count) {
                                const _start = moment(event.start)
                                that._daysToHighlight.push('.pika-day[data-pika-year="'+_start.format('YYYY')+'"][data-pika-month="'+_start.format('M')+'"][data-pika-day="'+_start.format('D')+'"]')
                                }*/

                    // @todo Check if any
                    if (appointment.max_pers_count !== "" && appointment.max_pers_count !== null) {
                      event.max_attendees = appointment.max_pers_count;
                    }

                    if (
                      appointment.current_available_pers_count !== "" &&
                      appointment.current_available_pers_count !== null
                    ) {
                      event.current_available_pers_count = appointment.current_available_pers_count;
                    }

                    event.appointment_id = appointment.id; // Can later be used to update appointment
                  }
                });
              });
            });

            resolve(sortedEvents);
          },
          error(error: any): void {
            reject(error);
          },
        },
      );
    },
  );
};
